import clsx from "clsx";
import { Select, Option, SelectProps } from "@repo/ui/select";
import classes from "./product-variant-select.module.css";

export type ProductVariantSelectorProps = {
  mappedVariants: MappedVariant[];
  onSelect: SelectProps["onSelect"];
  placeholder: SelectProps["placeholder"];
  itemIndicatorContent?: string | React.ReactNode;
  icon: React.ReactNode;
  selectItemClassName?: string;
  onOpenChange?: SelectProps["onOpenChange"];
} & SelectProps;

export type MappedVariant = {
  value: string;
  label: string;
  status: "default" | "disabled" | "alert";
  statusLabel?: string;
};

export const ProductVariantSelector = ({
  mappedVariants,
  onSelect,
  placeholder,
  itemIndicatorContent,
  icon,
  selectItemClassName,
  onOpenChange,
  ...props
}: ProductVariantSelectorProps) => (
  <Select
    onSelect={onSelect}
    placeholder={placeholder}
    icon={icon}
    onOpenChange={onOpenChange}
    {...props}
  >
    {mappedVariants.map(({ value, label, status, statusLabel }) => (
      <Option
        key={value}
        value={value}
        itemIndicatorContent={itemIndicatorContent}
        disabled={status === "disabled"}
        className={clsx(
          selectItemClassName,
          status === "disabled" && classes.disabledLabel,
        )}
      >
        <span className={classes.itemContent}>
          <span>{label}</span>
          {statusLabel && (
            <span className={clsx(status === "alert" && classes.alertLabel)}>
              {statusLabel}
            </span>
          )}
        </span>
      </Option>
    ))}
  </Select>
);
